// src/hooks/useNotification.js
import { useCallback } from "react";
import { notificationService } from "@/services/notificationService";


export default function useNotification() {
  /** Fetch all notification settings */
  const getAll = useCallback(async () => {
    const data = await notificationService.getAll();
    console.log("useNotification -> getAll data:", data);
    return data;   // IMPORTANT: this should be the array
  }, []);

  /** Update a single row (status or templates) */
  const updateStatus = async (id, payload) => {
    return notificationService.updateStatus(id, payload);
  };

  /** Dropdown options same as Angular fetchDropdownOptions() */
  const fetchDropdownOptions = useCallback(async () => {
    const res = await notificationService.getAll();
    const response = Array.isArray(res?.data) ? res.data : [];

    if (!Array.isArray(response) || response.length === 0) {
      return {
        whatsAppTemplates: [],
        smsTemplates: [],
        emailTemplates: [],
      };
    }

    const templateData = response.find(
      (item) =>
        item.whatsappTemplate || item.smsTemplate || item.emailTemplate
    );

    if (!templateData) {
      return {
        whatsAppTemplates: [],
        smsTemplates: [],
        emailTemplates: [],
      };
    }

    return {
      whatsAppTemplates: templateData.whatsappTemplate
        ? [
            {
              key: templateData.whatsappTemplate,
              value: templateData.whatsappTemplate,
            },
          ]
        : [],
      smsTemplates: templateData.smsTemplate
        ? [
            {
              key: templateData.smsTemplate,
              value: templateData.smsTemplate,
            },
          ]
        : [],
      emailTemplates: templateData.emailTemplate
        ? [
            {
              key: templateData.emailTemplate,
              value: templateData.emailTemplate,
            },
          ]
        : [],
    };
  }, []);

  return {
    getAll,
    updateStatus,
    fetchDropdownOptions,
  };
}
